module.exports = __webpack_public_path__ + "01_baby.d88e9bda.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/01_baby.png
// module id = OfW4
// module chunks = 0